<template>
  <el-dialog
    id="channel-details-dialog"
    ref="optinDialog"
    :title="dialogTitle"
    top="30vh"
    width="50rem"
    :show-close="true"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :visible.sync="showDialog"
    :destroy-on-close="true"
    :append-to-body="true"
  >
    <div class="channel-details">
      <label for="channelName" class="form-label text-primary">Channel Name:</label>
      <div class="channel-item">
        <social-icon class="fa fa-fw" :type="channel.channel" style="font-size: 30px" />
        <strong>{{ channel.channel }}</strong>
      </div>
      <div>
        <p><strong>Opt In:</strong><i :class="getIconClass(channel.opt_in)"></i></p>
        <p><strong>Opt Out:</strong> <i :class="getIconClass(channel.opt_out)"></i></p>
        <p><strong>Permission to Process:</strong> <i :class="getIconClass(channel.permission)"></i></p>
      </div>
      <p v-if="channel.date_opted_in" class="date-opted-in">
        <strong>Date Opted In:</strong> {{ formatDateOptedIn(channel.date_opted_in) }}
      </p>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'ChannelOptinDialog',
  components: {
    SocialIcon,
  },
  props: {
    channel: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('close', val);
      },
    },
    dialogTitle() {
      return 'Channel Opt-in & Permission';
    },
  },
  methods: {
    formatDateOptedIn(dateOptedIn) {
      return moment(dateOptedIn).format('dddd, MMMM D, YYYY');
    },
    getIconClass(condition) {
      return condition ? 'el-icon-check' : 'el-icon-close';
    },
  },
};
</script>

<style scoped>
.channel-details {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.channel-item {
  margin-bottom: 30px;
}

.date-opted-in {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// ChannelOptinDialog.vue?07c8e71c